import { Check } from 'lucide-react';

const StepperBar = ({ steps, currentStepIndex }) => (
  <div id="StepperBar_4" className="bg-white border-b border-[#f7f7f7] pt-4 sm:pt-6 pb-4 sm:pb-6 z-40">
    <div className="max-w-[1632px] mx-auto px-4 sm:px-6 lg:px-12 overflow-hidden">
      <div className="flex items-center justify-between min-w-0">
        {steps.map((step, index) => (
          <div key={index} className="flex items-center min-w-0">
            <div
              className={`flex items-center cursor-pointer ${currentStepIndex >= index ? 'opacity-100' : 'opacity-50'}`}
              onClick={() => step.onClickBack && step.onClickBack()}
              data-testid={`step-indicator-${index + 1}`}
            >
              <div className={`w-6 h-6 sm:w-10 sm:h-10 rounded-full flex items-center justify-center font-bold text-xs sm:text-base transition-colors ${
                currentStepIndex >= index ? 'bg-bush text-white' : 'bg-gray-200 text-gray-500'
              }`}>
                {currentStepIndex > index ? <Check className="h-3 w-3 sm:h-5 sm:w-5" /> : index + 1}
              </div>
              <div className="ml-2 sm:ml-3 hidden md:block">
                <p className="font-semibold text-sm text-[#1A1A1A]">{step.name}</p>
                <p className="text-xs text-gray-500">{step.description}</p>
              </div>
            </div>
            {index < steps.length - 1 && (
              <div className={`h-0.5 mx-1 sm:mx-2 flex-shrink min-w-1 sm:min-w-4 lg:min-w-12 max-w-24 ${currentStepIndex > index ? 'bg-bush' : 'bg-gray-200'}`} />
            )}
          </div>
        ))}
      </div>
    </div>
  </div>
);

export default StepperBar;
